import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
const COVER_URL = 'https://cdn.magicpatterns.com/uploads/mxhHXRmrKE17QFZqnjyvyS/pasted-image.png';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/5yJUmvh9YcA85AWox7xXA1/logo_neurolecturas.png';
export function Hero() {
  return <section className="relative min-h-screen w-full bg-[#0c1222] flex flex-col items-center justify-center overflow-hidden px-4 sm:px-6 lg:px-8 py-16 md:py-20" data-id="element-141">
      {/* Top Nav / Logo Bar */}
      <motion.div initial={{
      opacity: 0,
      y: -10
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} className="absolute top-0 left-0 w-full z-20 px-4 sm:px-6 lg:px-8 pt-5" data-id="element-142">
        <div className="max-w-6xl mx-auto flex items-center" data-id="element-143">
          <img src={LOGO_URL} alt="NeuroLecturas Pro logo" className="w-9 h-9 sm:w-10 sm:h-10 rounded-full object-cover flex-shrink-0" data-id="element-144" />
          <span className="ml-2.5 font-sans font-semibold text-white text-sm sm:text-base tracking-wide" data-id="element-145">
            NeuroLecturas Pro
          </span>
        </div>
      </motion.div>

      {/* Background geometric accents */}
      <div className="absolute top-0 left-0 w-full h-2 bg-[#c0392b]" data-id="element-146" />
      <div className="absolute bottom-0 right-0 w-1/3 h-1 bg-[#c0392b]" data-id="element-147" />
      <div className="absolute top-1/4 left-0 w-24 h-1 bg-white opacity-20" data-id="element-148" />

      {/* Two-column layout */}
      <div className="relative z-10 max-w-6xl w-full mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16" data-id="element-149">
        {/* Left: Text content */}
        <div className="flex-1 text-center lg:text-left" data-id="element-150">
          {/* Urgency Banner */}
          <motion.div initial={{
          opacity: 0,
          y: -20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="mb-6 inline-block bg-[#c0392b] px-4 py-1" data-id="element-151">
            <span className="text-white font-bold text-sm tracking-widest uppercase font-sans" data-id="element-152">
              ACTUALIZADO 2026
            </span>
          </motion.div>

          {/* Main Headline */}
          <motion.h1 className="font-serif font-black text-white leading-[0.9] tracking-tight" initial="hidden" animate="visible" variants={{
          hidden: {
            opacity: 0
          },
          visible: {
            opacity: 1,
            transition: {
              staggerChildren: 0.2
            }
          }
        }} data-id="element-153">
            <motion.div variants={{
            hidden: {
              y: 50,
              opacity: 0
            },
            visible: {
              y: 0,
              opacity: 1
            }
          }} className="text-[clamp(2.2rem,8vw,7rem)] block" data-id="element-154">
              No vivas con miedo,
            </motion.div>
            <motion.div variants={{
            hidden: {
              y: 50,
              opacity: 0
            },
            visible: {
              y: 0,
              opacity: 1
            }
          }} className="text-[clamp(2.2rem,8vw,7rem)] block text-[#c0392b]" data-id="element-155">
              vive con un plan.
            </motion.div>
          </motion.h1>

          {/* Subtitle */}
          <motion.p initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.8,
          duration: 0.8
        }} className="mt-6 text-base sm:text-lg md:text-xl text-gray-300 font-sans font-light max-w-xl mx-auto lg:mx-0 leading-relaxed" data-id="element-156">
            El Manual de Defensa para familias latinas + 8 Imprimibles prácticos
            para actuar en segundos.
          </motion.p>

          {/* CTA Button */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 1.2,
          duration: 0.5
        }} className="mt-8" data-id="element-157">
            <button className="group relative inline-flex items-center justify-center px-8 py-4 bg-[#c0392b] text-white font-bold uppercase tracking-widest text-base sm:text-lg hover:bg-[#a93226] transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#c0392b] focus:ring-offset-[#0c1222]" data-id="element-158">
              <span data-id="element-159">DESCARGAR MI GUÍA Y BONOS AHORA</span>
              <ArrowRight className="ml-3 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-160" />
              <div className="absolute inset-0 border border-white opacity-0 group-hover:opacity-20 transition-opacity duration-300 scale-105" data-id="element-161" />
            </button>
            <p className="mt-4 text-sm text-gray-400 font-sans" data-id="element-162">
              Disponible inmediatamente en formato digital PDF
            </p>
          </motion.div>
        </div>

        {/* Right: Book Cover */}
        <motion.div initial={{
        opacity: 0,
        x: 40,
        rotate: 2
      }} animate={{
        opacity: 1,
        x: 0,
        rotate: 0
      }} transition={{
        delay: 0.6,
        duration: 0.8,
        ease: 'easeOut'
      }} className="flex-shrink-0 w-full max-w-[300px] sm:max-w-[340px] lg:max-w-[400px]" data-id="element-163">
          <div className="relative" data-id="element-164">
            {/* Glow effect behind the book */}
            <div className="absolute -inset-4 bg-[#c0392b]/10 blur-2xl rounded-lg" data-id="element-165" />

            {/* Urgency Banner - positioned on the book cover */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.8
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            delay: 0.9,
            duration: 0.4,
            type: 'spring',
            stiffness: 200
          }} className="absolute -top-3 -right-3 z-20 bg-[#c0392b] px-5 py-1.5 shadow-lg rotate-3" data-id="element-166">
              <span className="text-white font-bold text-[1.05rem] tracking-widest uppercase font-sans" data-id="element-167">
                ACTUALIZADO 2026
              </span>
            </motion.div>

            {/* White frame around the book cover */}
            <div className="relative bg-white p-2 sm:p-3 shadow-[0_20px_60px_rgba(0,0,0,0.6),0_0_40px_rgba(192,57,43,0.15)]" data-id="element-168">
              <img src={COVER_URL} alt="Portada del ebook Invisibles pero Invencibles — Manual de Defensa para Latinos Sin Miedo" className="relative w-full h-auto block" loading="eager" data-id="element-169" />
            </div>
            {/* Subtle book spine effect */}
            <div className="absolute top-0 left-0 w-[3px] h-full bg-gradient-to-b from-white/20 via-white/5 to-white/20 rounded-l-sm" data-id="element-170" />
          </div>
        </motion.div>
      </div>

      {/* Decorative scroll indicator */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center opacity-50 animate-bounce" data-id="element-171">
        <div className="w-[1px] h-12 bg-white/30 mb-2" data-id="element-172" />
        <span className="text-xs tracking-widest uppercase text-white/50" data-id="element-173">
          Descubre Más
        </span>
      </div>
    </section>;
}